import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import axios from 'axios';

import format from '../../helpers/format';
import SelectedPoliciesDispatch from '../../contexts/selectedPolicies.dispatch';
import selectedPoliciesActions from '../../actions/selectedPolices.actions';

import Checkbox from './Checkbox';
import Submit from './PrimaryButton';
import style from './Quotes.module.css';

const omitProperty = (key, { [key]: value, ...props }) => {
  return props;
};

const Quotes = React.memo(({ clientId, submitBtnText = 'Submit Request' }) => {
  const selectedPoliciesDispatch = useContext(SelectedPoliciesDispatch);

  const [selected, setSelected] = useState({});
  const [quotes, setQuotes] = useState([]);
  const [sort, setSort] = useState({
    QuoteId: 'not',
    LineOfBusiness: 'not',
    BillingCarrier: 'not',
    EffDate: 'not',
    Premium: 'not',
  });

  const quoteSelected = () => {
    return Object.values(selected).some(item => {
      return item;
    });
  };

  const handleSelect = event => {
    const { value } = event.target;

    setSelected(
      selected[value]
        ? omitProperty(value, selected)
        : Object.assign({}, selected, {
            [value]: true,
          }),
    );
  };

  const handleSubmit = event => {
    event.preventDefault();

    selectedPoliciesDispatch({
      type: selectedPoliciesActions.SERVICE_REQUEST_POLICIES_SELECTED,
      ids: Object.keys(selected),
    });
  };

  const handleSort = event => {
    const { attributes } = event.target;
    const sortDirection =
      attributes.direction.value === 'desc' ? 'asc' : 'desc';

    setSort(
      Object.assign(
        {},
        {
          QuoteId: 'not',
          LineOfBusiness: 'not',
          BillingCarrier: 'not',
          EffDate: 'not',
          Premium: 'not',
        },
        { [attributes.sort.value]: sortDirection },
      ),
    );

    switch (sortDirection) {
      case 'desc':
        setQuotes(
          quotes.sort((a, b) => {
            if (a[attributes.sort.value] < b[attributes.sort.value]) {
              return -1;
            }
            if (a[attributes.sort.value] > b[attributes.sort.value]) {
              return 1;
            }
            return 0;
          }),
        );
        break;
      case 'asc':
        setQuotes(
          quotes.sort((a, b) => {
            if (b[attributes.sort.value] < a[attributes.sort.value]) {
              return -1;
            }
            if (b[attributes.sort.value] > a[attributes.sort.value]) {
              return 1;
            }
            return 0;
          }),
        );
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const handleSuccess = ({ data }) => {
      setQuotes(data);
    };

    // 160 is proposed status
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}hub/clients/${clientId}/quotes/160`,
      )
      .then(handleSuccess);
  }, [clientId]);

  return (
    <>
      <table className={style.quotes}>
        <thead>
          <tr>
            <th className={style.wFifty}>Select</th>
            <th
              sort="QuoteId"
              direction={sort.QuoteId}
              onClick={handleSort}
              className={`${style.wHundredThirtyFive} ${style[sort.QuoteId]}`}
            >
              Quote ID
            </th>
            <th
              sort="LineOfBusiness"
              direction={sort.LineOfBusiness}
              onClick={handleSort}
              className={`${style.wHundredFourty} ${
                style[sort.LineOfBusiness]
              }`}
            >
              Line of Business
            </th>
            <th
              sort="BillingCarrier"
              direction={sort.BillingCarrier}
              onClick={handleSort}
              className={`${style.wNinety} ${style[sort.BillingCarrier]}`}
            >
              Carrier
            </th>
            <th
              sort="EffDate"
              direction={sort.EffDate}
              onClick={handleSort}
              className={`${style.wHundredFourty} ${style[sort.EffDate]}`}
            >
              Effective Date
            </th>
            <th
              sort="Premium"
              direction={sort.Premium}
              onClick={handleSort}
              className={style[sort.Premium]}
            >
              Premium
            </th>
          </tr>
        </thead>
        <tbody>
          {quotes.length > 0 &&
            quotes.map(item => {
              return (
                <tr key={item.Id}>
                  <td>
                    <Checkbox
                      checked={selected[item.Id]}
                      value={item.Id}
                      disabled={
                        Object.keys(selected).length >= 3 && !selected[item.Id]
                      }
                      onChange={handleSelect}
                    />
                  </td>
                  <td>{item.QuoteId}</td>
                  <td>{item.LineOfBusiness}</td>
                  <td>{item.BillingCarrier}</td>
                  <td>{format.formatDate(item.EffDate)}</td>
                  <td>{format.formatMoney(item.Premium)}</td>
                </tr>
              );
            })}
          {quotes.length === 0 && (
            <tr>
              <td colSpan="6" />
            </tr>
          )}
        </tbody>
      </table>
      {quotes.length === 0 && (
        <div className={style.NotFound}>
          <div>No rows found</div>
        </div>
      )}
      <div className={style.actions}>
        <Submit
          disabled={!quoteSelected()}
          text={submitBtnText}
          styles={{ width: '200px' }}
          onClick={handleSubmit}
        />
        <Link to={`/clients/${clientId}`} className={style.cancelBtn}>
          Cancel
        </Link>
      </div>
    </>
  );
});

Quotes.propTypes = {
  clientId: PropTypes.string.isRequired,
  submitBtnText: PropTypes.string,
};

export default Quotes;
